export default {
  Default: {
    description: "Head of Security, Amperity",
    image: "https://wordsofourmothers.com/wp-content/uploads/2019/04/new-edited-pug.jpg",
    name: "Fluffy",
    title: "Author",
    url: "/"
  }
}
